<div class="branch-container">
    <img src="../../../../assets/images/logo-branches.svg" alt="Logo">
    <div class="branch-detail">
        <h3>{{ formattedName }}</h3>
        <p>{{ formattedAddress }}</p>
        <div class="maps-redirect">
            <button (click)="redirectToMap()">Cómo llegar</button>
        </div>
    </div>
</div>
